import { Typography, IconButton } from '@sweep-io/sweep-design';
import { DateBy } from '../../common/datepicker/types';
import { DatePickerRefProps, DatePickerWrapper } from '../../common/datepicker/DatePickerWrapper';
import { Stack } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { SettingsWrapper } from './Settings';
import { DEFAULT_DATEPICKER_STATE } from './utils';
import { AiAssistantFilters } from './types';
import { useFeatureToggle } from '../../../feature-flags/useFeatureToggle';
import { ArrowLeft } from '@sweep-io/sweep-design/dist/icons';
import { AiAssistantDialogWithMenu } from './dialog/AiAssistantDialogWithMenu';
import { useCallback, useState } from 'react';
import ToggleExpandButton from '../../aiAgentCenter/ToggleExpandButton';
import ClosePanelButton from '../../aiAgentCenter/ClosePanelButton';

interface AiAssistantPageHeaderProps {
  withFilters: boolean;
  setDateFilters: (dates: AiAssistantFilters) => void;
  datePickerRef: React.RefObject<DatePickerRefProps>;
  setAiAssistantDialogOpen: (open: boolean) => void;
  goBackCb?: () => void;
  isCollapsed?: boolean;
  handleClosePanel?: () => void;
}

export const AiAssistantPageHeader = ({
  withFilters,
  setDateFilters,
  datePickerRef,
  setAiAssistantDialogOpen,
  goBackCb,
  isCollapsed,
  handleClosePanel,
}: AiAssistantPageHeaderProps) => {
  const [AiAssistantDialogWithMenuOpen, setAiAssistantDialogWithMenuOpen] = useState(false);
  const { supportAgentInAgenticCenter } = useFeatureToggle();

  const openDialog = useCallback(() => {
    if (supportAgentInAgenticCenter) {
      setAiAssistantDialogWithMenuOpen(true);
    } else {
      setAiAssistantDialogOpen(true);
    }
  }, [supportAgentInAgenticCenter, setAiAssistantDialogOpen, setAiAssistantDialogWithMenuOpen]);

  const renderDateAndSettings = () => {
    return (
      <>
        {withFilters && (
          <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={1}>
            <Stack direction="row" gap={1} alignItems="center">
              <Typography variant="body" color={colors.grey[700]}>
                Date
              </Typography>
              <DatePickerWrapper
                onSelectDate={(value) =>
                  setDateFilters({
                    startTime: value[DateBy.From],
                    endTime: value[DateBy.To],
                  })
                }
                ref={datePickerRef}
                defaultValue={DEFAULT_DATEPICKER_STATE}
              />
            </Stack>
            <SettingsWrapper setAiAssistantDialogOpen={openDialog} isCollapsed={isCollapsed} />
          </Stack>
        )}
      </>
    );
  };

  return (
    <>
      <Stack direction="row" gap={3} justifyContent="space-between" alignItems="center">
        <AiAssistantDialogWithMenu
          isOpen={AiAssistantDialogWithMenuOpen}
          onClose={() => setAiAssistantDialogWithMenuOpen(false)}
        />

        <Stack alignItems="center" direction="row" gap={1}>
          {goBackCb && (
            <IconButton variant="flat" size="tiny" onClick={goBackCb}>
              <ArrowLeft size="medium" />
            </IconButton>
          )}

          <Typography variant={isCollapsed ? 'h5' : goBackCb ? 'h3' : 'h2'}>Support AI</Typography>
        </Stack>

        <Stack direction="row" gap={1} alignItems="center">
          {!isCollapsed && renderDateAndSettings()}
          {handleClosePanel && (
            <Stack direction="row" gap={1} alignItems="center">
              <ToggleExpandButton />
              <ClosePanelButton closePanel={handleClosePanel} />
            </Stack>
          )}
        </Stack>
      </Stack>
      {isCollapsed && <Stack pt={1}>{renderDateAndSettings()}</Stack>}
    </>
  );
};
